import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { formatMoney } from "../../services/utils/helpersFunc";
import moment from "moment";
import { adminRetryCustomerDebit } from "../../services/axios";
import { toast } from "react-toastify";

const RetryDebitModal = ({ isOpen, onClose, schedule }) => {
  const [loading, setLoading] = useState(false);

  const handleRetryDebit = async () => {
    const requestPath = window.location.pathname;
    setLoading(true);
    const res = await adminRetryCustomerDebit({
      id: schedule.id,
      loanType: requestPath.includes("instant-loan")
        ? "instant_loan"
        : "business_loan",
    });
    setLoading(false);
    if (res) {
      toast.success("Debit retry has been initiated successfully");
      onClose();
      window.location.reload();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="#540A45" fontWeight="700">
          Retry Debit Confirmation
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Alert status="warning" borderRadius="md">
              <AlertIcon />
              <VStack align="start" spacing={1}>
                <AlertTitle fontSize="sm">
                  Are you sure you want to retry the debit?
                </AlertTitle>
                <AlertDescription fontSize="sm">
                  This action will attempt to debit the customer's account again
                  for this repayment.
                </AlertDescription>
              </VStack>
            </Alert>

            <VStack
              spacing={2}
              align="stretch"
              bg="gray.50"
              p={4}
              borderRadius="md"
            >
              <Text fontSize="sm" color="gray.700">
                <strong>Due Date:</strong>{" "}
                {moment(schedule?.date, "YYYY-MM-DD").format("DD MMMM YYYY")}
              </Text>
              <Text fontSize="sm" color="gray.700">
                <strong>Amount Due:</strong> ₦
                {formatMoney(schedule?.amount_due)}
              </Text>
              <Text fontSize="sm" color="gray.700">
                <strong>Current Status:</strong>
                <Text
                  as="span"
                  color={schedule?.status === "Paid" ? "#1BB100" : "#FF0000"}
                  ml={2}
                >
                  {schedule?.status}
                </Text>
              </Text>
            </VStack>

            <Text fontSize="sm" color="gray.600">
              Please confirm that you want to proceed with retrying the debit
              for this repayment schedule.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            bg="#540A45"
            color="white"
            onClick={handleRetryDebit}
            isLoading={loading}
            loadingText="Processing..."
            _hover={{ bg: "#6B1A55" }}
          >
            Confirm Retry Debit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RetryDebitModal;
